import { get_next_wl_link } from "@iscr/views/med/utils";

import { useState, useEffect, Fragment } from 'react';
import { getConfig } from '@capacitor/live-updates'

import AdminMenu from './AdminMenu'
import MainMenuItems from './MainMenuItems'
import { useUser } from 'xAppLib/Hooks';
import IcosmSideMenu from '../../views/icosm/menu/IcosmSideMenu';
import IcosmMenu from '../MenuNav/IcosmMenu';
import ServiceAndConditionsMenu from '../../views/UIelems/v2/serviceAndConditionsMenu/ServiceAndConditionsMenu';
import CloseSVGIcon from '../../styles/public/icons/CloseSVGIcon';
import BottomMenu from './BottomMenu';
import { Transition, Menu, Dialog } from "@headlessui/react";
import { cls } from "../../views/NUI/utils";

const SideMenu = ({ showMenu=false, onMenuChange }) => {
	const user = useUser()
	const [devChannel, setDevChannel] = useState(false)
	const [menuView, setMenuView] = useState(null)
	const showCosmMenu = app.settings?.icosm && app.user.user_in && !app.acl.is_usr;

	useEffect(() => {
		app.on(app.events.SIDEMENU, ({ view }) => setMenuView(view ?? null));
	}, [])

	useEffect(() => {
		async function get_channel() {
			try {
				const info = await getConfig()
				setDevChannel(info?.channel === 'dev')
			} catch (e) {
				console.error(e)
			}
		}
		if (app.settings.is_ionic) {
			get_channel()
		}
	}, [])

	return (
		<Transition.Root show={showMenu} as="div">
			<Dialog
				className="relative !z-[100010] h-screen"
				onClose={() => onMenuChange?.(false)}
			>
				{/* Overlay */}
				<Transition.Child
					as={Fragment}
					enter="transition-opacity duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="transition-opacity duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
					><div className="bm-overlay fixed inset-0 bg-black/30"></div>
				</Transition.Child>

				{/* Panel */}
				<div className="fixed inset-0 flex items-center justify-center">
					<Transition.Child
						as={Fragment}
						enter="transform transition duration-500"
						enterFrom="translate-x-full"
						enterTo="translate-x-0"
						leave="transform transition duration-500"
						leaveFrom="translate-x-0"
						leaveTo="translate-x-full"
						>
						<Dialog.Panel className={`bm-menu ${user.user_in ? 'user-in' : ''} h-full w-full lg:w-[741px] overflow-y-scroll no-scrollbar fixed right-0 top-0 lg:pb-[80px] lg:pt-0`}>
							<div tabIndex={0} className="sr-only" aria-hidden={true}></div>
							{app.settings.iscr2 &&
								<> 
									<nav className="!flex lg:!hidden !justify-between !items-center p-4 !text-white !fixed !w-full !top-0 !bg-is2-blue !mb-0 z-50">
										<div className='!pt-safe !flex !justify-between !items-center !w-full'>
											<img
												src={app.runtime.sidemenuLogo || "/images/logos/instant-scripts-logo-IS2-white.svg"}
												className="!m-0 !p-0 !h-6"
												alt="logo"
											/>
										</div>
									</nav>
									<Menu
										as="div"
										className="side-menu text-black !mt-0 vertical fluid pt-safe"
										data-testid="menu-collapsible"
										>
										<ServiceAndConditionsMenu onMenuChange={onMenuChange} showMenu={showMenu} wl_link={get_next_wl_link()} initialView={menuView} />
										<BottomMenu closeMenu={() => onMenuChange(false)} runtime={app.runtime.name} ketchDisplay={__KETCH_DISPLAY__} />
									</Menu>
								</>
							||
								<>
									{(app.settings.icosm && !user.user_in) && <IcosmMenu inSideMenu onMenuChange={onMenuChange} />}
									<div
										className="side-menu"
										data-testid="menu-collapsible"
										// The cosm menu is an accordion, so a blanket close-on-click here closed the
										// whole drawer when expanding a top-level item. It reports real navigation
										// via onNavigate instead. MainMenuItems is a flat list of links with nothing
										// to expand, so close-on-click is still correct there.
										onClick={showCosmMenu ? undefined : () => onMenuChange?.(false)}
									>
										{showCosmMenu
											? <IcosmSideMenu onNavigate={() => onMenuChange?.(false)} />
											: <MainMenuItems inSideMenu />}
									</div>
								</>
							}
							<button onClick={_ => { onMenuChange?.(false) }} className={cls("pt-safe fixed top-0 right-0 mt-4 mr-4 z-50 rounded-full focus:outline-none focus-visible:ring-2", app.settings.iscr2 && "lg:hidden text-white focus-visible:ring-white", app.settings.icosm &&"text-icosm-gold focus-visible:ring-icosm-gold")} aria-label="close dialog" data-testid="button-close-side-menu">
								<CloseSVGIcon width={26} height={26} fill={app.settings.iscr2 && "#005BDA"||""} />
							</button>

							{user.claims.admin && <AdminMenu inverted vertical inSideMenu closeMenu={() => onMenuChange(false)} />}
							{app.settings.is_ionic && <Menu
								as="div"
								className='side-meta ui menu inverted vertical fluid px-2 pb-2'
								onClick={_ => onMenuChange?.(false)}
								>
								<Menu.Item as="div" fitted='vertically'>© {new Date().getFullYear()} InstantScripts</Menu.Item>
								<Menu.Item as="div" className='text-sm'>Build: {__GIT_HASH__} - {__BUILD__} {devChannel && "dev"}
								{app.runtime.org && <i><br />{app.runtime.org.name}</i> || null}
								{app.dvc.org && <><br />{app.dvc.org.name}</> || null}</Menu.Item>
							</Menu>}
						</Dialog.Panel>
					</Transition.Child>
				</div>
			</Dialog>
		</Transition.Root>
	)
}

export default SideMenu;
